/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__, or convert again using --optional-chaining
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Bulletin schedule editor controller
//
// This is the controller to link the EventInstance in-memory model with the page itself.
//
// Expects each item to be in an element with data-instance=true and data-date=start_date
//
// Inside, a click on something with data-action="remove-instance" will remove the instance
// and the associated element
//
// The form used for adding instances is the add_form option.
//   A data-action="add-instance" inside will add an instance
//   Will use data-instance to determine what type of data it is,
//     "start-date" "start-time" or "end-time"
//   Recurrence is supported with
//     "recurrence-ends" "recurrence-type" and "recurrency-day"
//
//   Recurrence types are 'daily', 'weekly', 'monthly'
//   Recurrence days is 0-6 for days of week (can be multiple)
//
//   The other instances should be date inputs
//
// Events will be triggered on the instance container when an instance is added
// or deleted.  The extra parameter for each event is a hash with start_date, start_time,
// end_time.
//   slzr:instance:add => Triggered when an instance is added
//   slzr:instance:remove => Triggered when an instance is removed

import $ from 'jquery';
import _ from 'underscore';
import React from 'react';
import ReactDOM from 'react-dom';
import { EventInstances } from '../event_instance_manager/event_instances';
import { EventEmitter } from '../event_emitter';
import { ScheduleFormComponent } from './schedule_form/form_component.jsx';

export class CampaignScheduleEditor extends EventEmitter {
        constructor(options) {
          super();
          this._attachEvents = this._attachEvents.bind(this);
this._initializeUI = this._initializeUI.bind(this);

          this.options = $.extend({}, this.default_options, options);

          this.form = $(this.options.form);

          this.instances = new EventInstances({
            max_instances:     this.options.max_instances,
            max_range:         this.options.max_range,
            initial_instances: this.options.initial_instances
          });

          this._attachEvents();
          this._initializeUI();
        }

        // Attach event handlers to the appropriate events
        _attachEvents() {
          // Make sure we have at least one valid date
          return this.form.on('validation:complete', (event, data) => {
            if (this.instances.valid()) {
              return this.form.find('[data-instance-error="need-date"]').hide();
            } 
              this.form.find('[data-instance-error="need-date"]').show();
              return (data.errors != null ? data.errors.push('A valid date must be entered') : undefined);
            
          });
        }

        _initializeUI() {
          const my = this;

          // Read the initial schedule state from the form fields
          const form_data = this.form.find(':input').serializeArray();

          const schedule_data = {
            start_date: null,
            send_time: (new Date()).getHours(),
            recurrence_type: 'manual',
            interval: 1
          };

          for (var i of ['send_time', 'recurrence_type', 'start_date', 'end_date', 'interval', 'recurrence_count', 'weekdays']) {
            const v = __guard__(_.find(form_data, item => item.name === `bulletin_campaign[${i}]`), x => x.value);
            if (!_.isBlank(v)) { schedule_data[i] = v; }
          }

          return ReactDOM.render(React.createElement(ScheduleFormComponent, {
              eventInstances: this.instances,
              onInstancesAdded: this._userAddedInstances,
              onInputChange: this._userChangedInputs,
              scheduleData: schedule_data,
              campaignKind: this.options.kind
            }
            ),
            this.form.get(0));
        }
}

CampaignScheduleEditor.prototype.default_options = {
  max_instances: 20,
  max_range: 366,
  form: null
};


// Activate schedule manager if the page has the inputs on it
Slzr.jQuery(function($) {
  const $form = $('[data-campaign-schedule="form"]');
  if (!($form.length > 0)) { return; }

  let kind = $form.data('campaign-kind');
  if (!kind) { kind = 'Email'; }

  return top.campaign_schedule_manager = new CampaignScheduleEditor({
    form: $form,
    initial_instances: [],
    kind
  });
});

function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
}